
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class VoidVoidEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             // Deep shadow layers
             for (let i = 0; i < 3; i++) {
                 const r = (500 + i * 500) * scale * (1 / (layerIndex + 1));
                 const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
                 grad.addColorStop(0, 'transparent');
                 grad.addColorStop(0.5, 'rgba(0,0,0,0.5)');
                 grad.addColorStop(1, 'transparent');
                 
                 ctx.save();
                 ctx.fillStyle = grad;
                 ctx.fillRect(-width * 2, -height * 2, width * 4, height * 4);
                 ctx.restore();
             }
             
             // Occasional distant spec
             if (this.pseudoRandom(Math.floor(time)) > 0.95) {
                 ctx.save();
                 ctx.globalAlpha *= 0.1;
                 ctx.beginPath();
                 ctx.arc(0, 0, 200 * scale, 0, Math.PI * 2);
                 ctx.fill();
                 ctx.restore();
             }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
